import React from 'react';
import Thumbnail from 'components/Thumbnails/Thumbnail';

import styles from './SelectableProjectCard.module.scss';

const SelectableProjectCard = ({
  className = '',
  onClick,
  project,
  selected = false,
}) => {
  return (
    <div
      className={`${styles.container} ${
        selected ? styles.selected : ''
      } ${className}`}
    >
      <div className={styles.project} onClick={onClick}>
        <Thumbnail
          className={styles.thumbnail}
          thumbnails={project.thumbnails}
        />
        <div className={styles.title}>{project.title}</div>
      </div>
    </div>
  );
};

export default SelectableProjectCard;
